module.exports = __webpack_public_path__ + "static/media/mp.d4c8612c.svg";